import { useReadContract } from "wagmi";
import useDappChain from "./useDappChain";
import useDappConfig from "./useDappConfig";
import { formatUnits } from "viem";
import { useSelector } from "react-redux";
import { ETH } from "@config/contractsConfig";
import { safeParseUnits } from "@lib/utils";

const useUnstakeEstimate = (amount: string) => {
  const { chain, isEthereumChain } = useDappChain();
  const { config, isRestakeSupported } = useDappConfig();
  const { selectedERC20 } = useSelector((state: any) => state.user);

  const assetToWithdrawInto =
    selectedERC20 === ETH ? config.nativeToken : config.tokens[selectedERC20];

  // safeParseUnits never throws on malformed input (hex, exponential, multi-dot,
  // Infinity, …) — those previously crashed this hook during render.
  const formattedAmount = safeParseUnits(amount, 18);

  const { data } = useReadContract({
    ...config.interactionPools.lrtWithdrawalManager,
    functionName: "getExpectedAssetAmount",
    args: [assetToWithdrawInto?.address, formattedAmount],
    query: {
      enabled:
        chain &&
        isRestakeSupported &&
        isEthereumChain &&
        formattedAmount > 0n &&
        !!assetToWithdrawInto,
    },
  });

  return data
    ? {
        returns: formatUnits(data as bigint, 18),
      }
    : { returns: "0" };
};

export default useUnstakeEstimate;
